/* eslint-disable */
import axios from 'axios'

function randomString(len) {
  len = len || 32
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';   
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd
}
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: 'https://develop.line-found.com/api/',
  timeout: 3000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = '6666' // getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code !== 1) {
    //   return Promise.reject(new Error(res.msg || 'Error'))
    // } else {
    //   return res
    // }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

const fetchPost = (url, params) => {
  const Qs = require('qs');
  return new Promise((resolve, reject) => {
    service.post(url, Qs.stringify(params)).then(data => {
      resolve(data)
    }).catch(err => {
      reject(err)
    })
  })
}

const fetchGet = (url, params) => {
  return new Promise((resolve, reject) => {
    service.get(
      url,
      {
        params: params
      }
    ).then(data => {
      resolve(data)
    }).catch(err => {
      reject(err)
    })
  })
}

export { fetchPost, fetchGet }
/* eslint-disable */